import { useState } from 'react';
import { api } from '@/shared/api/cliente';
import { ErrorDeApi } from '@/shared/api/problema';
import { notificar } from '@/shared/ui/avisos';

export function useComprobante() {
  const [ride, setRide] = useState<Blob | null>(null);
  const [ocupado, setOcupado] = useState<number | null>(null);

  async function abrirRide(facturaId: number, historica = false) {
    setOcupado(facturaId);
    setRide(null);
    try {
      const fichero = await api.descargar(
        `/facturas/${facturaId}/ride.pdf${historica ? '?historica=true' : ''}`,
      );
      if (!fichero) {
        notificar.error('NO SE PUDO GENERAR EL RIDE');
        return;
      }
      setRide(fichero);
    } catch (causa) {
      notificar.error(causa instanceof ErrorDeApi ? causa.message : 'NO SE PUDO ABRIR EL RIDE');
    } finally {
      setOcupado(null);
    }
  }

  async function descargarXml(facturaId: number, numero: string | null, historica = false) {
    setOcupado(facturaId);
    try {
      const fichero = await api.descargar(
        `/facturas/${facturaId}/comprobante.xml${historica ? '?historica=true' : ''}`,
      );
      if (!fichero) {
        notificar.error('NO SE PUDO OBTENER EL COMPROBANTE');
        return;
      }

      const url = URL.createObjectURL(fichero);
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = `${numero ?? facturaId}.xml`;
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();
      URL.revokeObjectURL(url);
    } catch (causa) {
      notificar.error(causa instanceof ErrorDeApi ? causa.message : 'NO SE PUDO OBTENER EL XML');
    } finally {
      setOcupado(null);
    }
  }

  return { ride, ocupado, abrirRide, descargarXml, cerrar: () => setRide(null) };
}
